import { render, staticRenderFns } from "./NewVersionBanner.vue?vue&type=template&id=1d277e67"
import script from "./NewVersionBanner.vue?vue&type=script&lang=js"
export * from "./NewVersionBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports